<script>
    import { onMount } from 'svelte'
    import Icon from 'fa-svelte'
    import { faPlusCircle } from '@fortawesome/free-solid-svg-icons/faPlusCircle'
    import { faCheckCircle } from '@fortawesome/free-solid-svg-icons/faCheckCircle'

    import { PreferredTime, fetchPreferredTime, preferredTimeTpl, submitPreferredTime } from 'src/store/candidates'
    import Btn from 'src/fields/Button.svelte'
    import Segment from './Segment.svelte'

    export let uid
    let preferredTime = []
    let isSaved = false

    onMount(() => {
        fetchPreferredTime(uid)
    })

    const refreshLocalPreferredTime = time => preferredTime = time

    const addSegment = async () => {
        preferredTime = [...preferredTime, preferredTimeTpl]
    }

    const submit = async () => {
        await submitPreferredTime(candidate)
        isSaved = true
    }
    const removeSegment = segment => preferredTime = preferredTime.filter(s => s != segment)

    $: candidate = { uid, preferred_time: preferredTime }
    $: refreshLocalPreferredTime($PreferredTime)
</script>

<main class="wrapper">
    <h1 class="header">Preferred time</h1>

    {#if isSaved}
        <div class="success">
            <span class="success-icon"><Icon icon={faCheckCircle}/></span>Thank you!
        </div>
    {:else}
        <div class="form">
            <div class="hint">Please specify your preferred interview time in <strong>PT timezone</strong></div>

            {#each preferredTime as segment}
                <Segment bind:segment={segment} on:remove={() => removeSegment(segment)}/>
            {/each}


            <div class="btn-wrapper">
                <Btn on:click={addSegment} size="small">
                    <Icon icon={faPlusCircle}/> &nbsp;Add range
                </Btn>

                {#if preferredTime.length}
                    <Btn on:click={submit}>Submit</Btn>
                {/if}
            </div>
        </div>
    {/if}
</main>

<style>
    main {
        width: 560px;
        max-width: 100vw;
        padding: 10px;
    }

    .header {
        font-size: 18px;
    }

    .hint {
        margin-bottom: 10px;
    }

    .btn-wrapper {
        display: flex;
        justify-content: space-between;
        align-items: center;
    }

    .success {
        background-color: #f3f3f3;
        padding: 30px;
        border-radius: 6px;
        display: flex;
        justify-content: center;
        align-items: center;
    }

    .success-icon {
        font-size: 24px;
        color: #17a185;
        margin-right: 6px;
    }
</style>
